import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, useLocale } from '@hooks/useLocale';

/**
 * Language switch for the pre-login pages (#2560): one button per entry in
 * SUPPORTED_LOCALES from the useLocale hook, so a new locale needs no change
 * here.
 */
export function BrandLanguageSwitch() {
  const { t } = useTranslation();
  const { locale, setLocale } = useLocale();

  return (
    <nav
      className="fc-lang"
      aria-label={t('auth.shell.languageNav')}
      data-testid="brand-language-switch"
    >
      {SUPPORTED_LOCALES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          lang={code}
          aria-pressed={code === locale}
          onClick={() => setLocale(code)}
        >
          {label}
        </button>
      ))}
    </nav>
  );
}
